function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SintEustatiusFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4649",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4649)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H24V21H0V3Z",
      fill: "#00268D"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.5 3.5H23.5V20.5H0.5V3.5Z",
      fill: "#00268D",
      stroke: "#E31D1C"
    }), /*#__PURE__*/_jsx("rect", {
      x: "11.25",
      y: "3",
      width: "1.5",
      height: "18",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("rect", {
      y: "12.75",
      width: "1.5",
      height: "24",
      transform: "rotate(-90 0 12.75)",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.2572 7.07125L12 6.9169L11.7428 7.07125L4.24275 11.5713L3.52817 12L4.24275 12.4287L11.7428 16.9287L12 17.0831L12.2572 16.9287L19.7572 12.4287L20.4718 12L19.7572 11.5713L12.2572 7.07125Z",
      fill: "white",
      stroke: "#E31D1C"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4649",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "6",
      width: "20",
      height: "12",
      children: /*#__PURE__*/_jsx("path", {
        d: "M12.2572 7.07125L12 6.9169L11.7428 7.07125L4.24275 11.5713L3.52817 12L4.24275 12.4287L11.7428 16.9287L12 17.0831L12.2572 16.9287L19.7572 12.4287L20.4718 12L19.7572 11.5713L12.2572 7.07125Z",
        fill: "white",
        stroke: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4649)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.23383 14.7C7.50284 14.7 20.625 14.7 20.625 14.7L19.2091 13.2643C19.2091 13.2643 16.3778 10.4256 16.1956 10.2955C16.0134 10.1654 15.7124 10.1092 15.3699 10.5227C15.0273 10.9362 14.8309 10.2955 14.5457 10.2955C14.2605 10.2955 14.1399 10.2955 13.7261 10.826C13.3124 11.3565 11.8223 13.2643 11.8223 13.2643H9.63252C9.63252 13.2643 9.26312 12.9509 9.0526 13.0628C8.84208 13.1746 7.65623 11.8259 7.23383 11.7251C6.81144 11.6244 6.53352 12.0907 6.53352 12.4618C6.53352 12.8329 6.33476 12.1218 5.93062 12.3305C5.52647 12.5393 5.65677 13.0628 5.65677 13.0628C5.65677 13.0628 6.96483 14.7 7.23383 14.7Z",
        fill: "#059334"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5048 11.3012L9.57845 12L9.91837 10.8457L9 10.1391H10.1441L10.5048 9L10.887 10.1391H12L11.0896 10.8457L11.4357 12L10.5048 11.3012Z",
        fill: "#FEDA00"
      })]
    })]
  })]
}));
//# sourceMappingURL=SintEustatius.js.map